import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  .ant-table-thead > tr > th {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.black5};
  }
`;

export const TitleWrapper = styled.h4`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const HeaderWrapper = styled.div`
  flex-direction: column;
  display: flex;
  gap: 16px;
  margin-top: 16px;
`;
